export default "__VITE_ASSET__Ct90XGai__"